export const appRoutes = {
  AUTH: 'auth',
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  CUSTOMERS: 'customers',
  SUPER_ADMINS: 'super-admins',
  EMAIL_CONFIRMATION: 'confirm-account',
  LOGOUT: 'logout',
};
